
var GenesysChat = {
    constants: {
        chatBotDeploymentId: Shopify.country == "US" ? '2d781926-f5ea-40c0-a31a-1cbbab15cc65': '1ec8b27e-fea5-421e-acd4-9dca5b8b1a48',
        country: Shopify.country,
        languageCountry: Shopify.locale + "-" + Shopify.country,
        genesysApp: '.genesys-app',
        environment: 'prod-euw1',
        //genesysUrl: (countryCode == "US" || countryCode == "CA") ? "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js" : "https://apps.mypurecloud.ie/genesys-bootstrap/genesys.min.js"
        genesysUrl: "https://apps.mypurecloud.ie/genesys-bootstrap/genesys.min.js",
        trackingIds: {
            open: 'ChatBot_Open',
            send: 'ChatBot_Send',
            close: 'ChatBot_Close'
        },
        analyticsOptOutAttribute: 'data-analytics_available_call',
        // CTA che aprono la chat: launcher flottante, bottone negli overlay e gli anchor
        // inline che arrivano dalle stringhe di traduzione (contact us).
        chatTriggers: '#chatbot-element, .op-open-chat, [onclick*="GenesysChat"]'
    },

    init: function () {

        subscribe("change-country", () => {Genesys("command", "Messenger.clear")});

        (function (g, e, n, es, ys) {
            g['_genesysJs'] = e;
            g[e] =
                g[e] ||
                function () {
                    (g[e].q = g[e].q || []).push(arguments);
                };
            g[e].t = 1 * new Date();
            g[e].c = es;
            ys = document.createElement('script');
            ys.async = 1;
            ys.src = n;
            ys.charset = 'utf-8';
            document.head.appendChild(ys);
        })(window, 'Genesys', GenesysChat.constants.genesysUrl, {
            environment: GenesysChat.constants.environment,
            deploymentId: GenesysChat.constants.chatBotDeploymentId,
            debug: false
        });

        Genesys("command", "Database.set", {
            messaging: {
                customAttributes: {
                    "webmsg_brandcode": 'OP',
                    "webmsg_country": Shopify.country,
                    "webmsg_language": Shopify.locale + "-" + Shopify.country
                }
            }
        })

        let flag = true;
        const observer = new MutationObserver(() => {
            if(sessionStorage.getItem("showHelpChatbot") == null) {
                observer.disconnect();
                return;
            }
            if(flag) {
                flag = false;
                GenesysChat.buttonDisplaySettings();
            }
            if(GenesysChat.hideChat()) observer.disconnect();
        });
        observer.observe(document.body, {childList: true});

        this.bind();
    },

    /**
     * Invia un evento di interazione con la chat a Tealium.
     * Passa da window.sendTealiumEvent (snippets/tealium.liquid) quando disponibile, cosi il
     * payload riceve la sanitizzazione standard; fallback sul push diretto alla coda.
     * Non solleva mai eccezioni: utag.js bloccato o lento non deve rompere la chat.
     * @param {string} elementId Valore inviato come data_element_id, vedi constants.trackingIds.
     * @returns {void}
     */
    trackChatEvent: function (elementId) {
        if (!elementId) return;

        const payload = {
            'id': 'Click',
            'data_element_id': elementId,
            'data_analytics_available_call': '1',
        };

        try {
            if (typeof window.sendTealiumEvent === 'function') {
                window.sendTealiumEvent(payload);
                return;
            }

            if (typeof tealium_data2track !== 'undefined' && typeof tealium_data2track.push === 'function') {
                tealium_data2track.push(payload);
            }
        } catch (error) {
            if (typeof console !== 'undefined' && console.warn) {
                console.warn('[GenesysChat] Tealium tracking failed', error);
            }
        }
    },

    /**
     * Esclude un elemento e il suo sottoalbero dal click tracking automatico di Tealium.
     * @param {Element|null} element
     * @returns {void}
     */
    disableAutoTracking: function (element) {
        if (!element || typeof element.setAttribute !== 'function') return;
        if (element.getAttribute(GenesysChat.constants.analyticsOptOutAttribute) === '0') return;
        element.setAttribute(GenesysChat.constants.analyticsOptOutAttribute, '0');
    },

    /**
     * Marca il contenitore del widget Genesys, cosi i click su link e bottoni interni
     * alla chat non generano chiamate di tracking non richieste.
     * @returns {void}
     */
    tagChatContainer: function () {
        GenesysChat.disableAutoTracking(document.querySelector(GenesysChat.constants.genesysApp));
    },

    /**
     * Esclude dall'autotrack tutte le CTA che aprono la chat: l'evento ChatBot_Open lo
     * inviamo esplicitamente da startChatbot, l'autotrack genererebbe un click duplicato.
     * Gestito via JS e non in markup perche' parte degli anchor vive dentro le stringhe di
     * traduzione (templates.contact.subtitle_2_html), rigenerabili dal language editor di Shopify.
     * @returns {void}
     */
    tagChatTriggers: function () {
        document.querySelectorAll(GenesysChat.constants.chatTriggers)
            .forEach((elem) => GenesysChat.disableAutoTracking(elem));
    },

    bind: function () {
        // Contenenete logiche di binding, 
        // gestite tramite hook di Genesys per poter, ad esempio, 
        // tracciare gli analytics in caso di apertura o chiusura della chat

        Genesys('subscribe', 'Messenger.ready', function (o) {
            // Subito, non dentro il setTimeout: nel frattempo il widget e' gia' nel DOM
            // e un click sul launcher Genesys verrebbe raccolto dall'autotrack.
            GenesysChat.tagChatContainer();

            // if (sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0) {
            //     $('#chatbot-element').show();
            // }
            // $('[aria-label="chat with us"]').css('pointer-events', 'unset');
            setTimeout(() => {
                GenesysChat.tagChatContainer();
                if(sessionStorage.getItem("showHelpChatbot") != null) GenesysChat.hideChat();
                else document.querySelector(GenesysChat.constants.genesysApp).style.display = 'none';
            }, 1000);
        });

        Genesys('subscribe', 'MessagingService.messagesReceived', function (o) {
            // Solo i messaggi di testo scritti dall'utente: all'apertura Genesys invia in automatico
            // messaggi Inbound non testuali (eventi di sessione) che non vanno contati come Send.
            const messages = o && o.data && Array.isArray(o.data.messages) ? o.data.messages : [];
            const hasCustomerTextMessage = messages.some(function (message) {
                return message && message.direction === 'Inbound' && message.type === 'Text';
            });
            if (!hasCustomerTextMessage) return;

            GenesysChat.trackChatEvent(GenesysChat.constants.trackingIds.send);
        });
        Genesys('subscribe', 'Conversations.opened', function (o) {
            GenesysChat.tagChatContainer();
        });

        Genesys('subscribe', 'Conversations.closed', function (o) {
            GenesysChat.hideChat();

            GenesysChat.trackChatEvent(GenesysChat.constants.trackingIds.close);
        });

        GenesysChat.tagChatTriggers();

        // Custom button to open chat and close other modals
        document.querySelectorAll('.op-open-chat').forEach(elem => elem.addEventListener('click', (event) => {
            event.target.closest('dialog').click()
            if(event.target.closest('dialog')) {
                setTimeout(() => {
                GenesysChat.startChatbot();
                }, "500");
            }   
            
        }))

    },

    startChatbot: function (e) {
        // Avvio della chat Genesys
        Genesys("command", "Database.set", {
            messaging: {
                customAttributes: {
                    "webmsg_brandcode": 'OP',
                    "webmsg_country": Shopify.country,
                    "webmsg_language": Shopify.locale + "-" + Shopify.country
                }
            }
        });
        GenesysChat.showChat();
        Genesys("command", "Messenger.open", {},
            function (o) { }, // if resolved
            function (o) { // if the chat is opened but not dispyable 
                GenesysChat.showChat();
            }
        );

        sessionStorage.setItem("showHelpChatbot", "true");

        GenesysChat.buttonDisplaySettings();

        GenesysChat.trackChatEvent(GenesysChat.constants.trackingIds.open);
    },

    buttonDisplaySettings: function () {
        let height = 0;
        document.querySelectorAll(".shopify-section-group-footer-group").forEach((node) => height += node.offsetHeight);
        document.addEventListener("scroll", () => {
            const scrollPosition = window.scrollY + window.innerHeight;
            const hidePosition = document.body.offsetHeight - height + window.innerHeight;
            if(scrollPosition > hidePosition) {
                GenesysChat.displayChatbotElement("none");
            } else {
                if(sessionStorage.getItem("showHelpChatbot") != null && document.getElementById('genesys-messenger').style.display == 'none'){
                    GenesysChat.displayChatbotElement("block");
                }
                    
            }
        })
    },

    /**
     * Alias retrocompatibile per eventuali handler inline legacy.
     * Il tracking dell'apertura vive in startChatbot, unico entry point di tutte le CTA della chat.
     * @returns {void}
     */
    openChat: function (e) {
        GenesysChat.startChatbot();
    },

    showChat: function (e) {
        // Visualizzazione della chat
        GenesysChat.tagChatContainer();
        document.querySelector(GenesysChat.constants.genesysApp).style.display = 'block';
        this.displayChatbotElement("none");
        // $(GenesysChat.constants.genesysApp).show();
        //$('#chatbot-element').hide();
    },

    hideChat: function (e) {
        if(document.querySelector(GenesysChat.constants.genesysApp)) document.querySelector(GenesysChat.constants.genesysApp).style.display = 'none';
        // $(GenesysChat.constants.genesysApp).hide();
        if(sessionStorage.showHelpChatbot != null){
            this.displayChatbotElement("block");
        }
        
        // if (sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0) {
        //     $('#chatbot-element').show();
        // }
        // sessionStorage.setItem("chatbotOpened", false);
    },

    displayChatbotElement(display) {
        const chatbot = document.querySelector("#chatbot-element");
        if(!chatbot) return;
        chatbot.style.display = display;
    }

    // onLoadHandler: function () {

    //     //calculate margin to hide entry point when touch the footer
    //     var margin;
    //     if (isOliver) {
    //         if ((window.mobilecheck() || window.tabletPortraitCheck())) {
    //             margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom'))) * 4 + 'px';
    //         } else {
    //             margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom'))) * 2 + 'px';
    //         }
    //     } else {
    //         margin = ($('#chatbot-element').height() + parseFloat($('#chatbot-element').css('padding-top')) + parseFloat($('#chatbot-element').css('padding-bottom'))) * 1.5 + 'px';
    //     }

    //     var options = {
    //         root: null,
    //         rootMargin: margin,
    //         threshold: 0.5
    //     }
    //     var observer = new IntersectionObserver(GenesysChat.onScrollHandler, options);

    //     var footerDesk = document.querySelector('.shopify-section-group-footer-group');
    //     observer.observe(footerDesk);
    // },
    // onScrollHandler: function (entries, observer) {
    //     entries.forEach(function (entry) {
    //         if (entry.isIntersecting) {
    //             $('#chatbot-element').hide();
    //         } else {
    //             if (sessionStorage.showHelpChatbot != null && $('#chatbot-element').length > 0 && $('#genesys-messenger').is(":hidden"))
    //                 $('#chatbot-element').show();
    //         }
    //     });
    // }
}

GenesysChat.init();

// document.addEventListener('DOMContentLoaded', function () {
//     GenesysChat.onLoadHandler();
// });

